<template
  src="./HeaderTitle.html"
></template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {};
  },
  components: {},
  computed: {
    ...mapState(['userAgent']),
    sectionName() {
      if (this.$store.getters.activeSection.name) {
        return this.$store.getters.activeSection.name;
      }
    },
    mobileScrollDuration() {
      if (this.userAgent.screentest) {
        return 1;
      } else {
        return 300;
      }
    },
    headerClass() {
      return {
        header__section: true,
        expanded:
          this.titleState === 'menu' ||
          this.titleState === 'title' ||
          this.titleState === 'section-1' ||
          this.titleState === 'footer',
        'header__section--large': this.titleState === 'basic-large',
        'header__section--title': this.titleState === 'title',
        'header__section--main-section': this.titleState === 'section-1',
        'header__section--footer':
          this.titleState === 'footer' &&
          this.$store.getters.page === 'psoriasis',

        //tremfya
        'header__section--tremfya':
          this.titleState !== 'footer' &&
          this.$store.getters.page === 'tremfya',
        'header__section--footer-blue':
          this.titleState === 'footer' && this.$store.getters.page === 'tremfya'
      };
    },
    headerAnimClass() {
      return this.titleState === 'title' ||
        this.titleState === 'section-1' ||
        this.titleState === 'footer'
        ? 'header-anim-bg'
        : '';
    }
  },
  props: ['titleState', 'menuItems', 'choosenMenuName'],
  name: 'header-title',
  methods: {
    screenDependantOffset(num) {
      // console.log(num);
      let off = this.userAgent.device.isPhone ? -35 : 0;
      if (
        this.$route.name.includes('Tremfya') &&
        (parseInt(num) === 4 || parseInt(num) === 5)
      ) {
        off += this.userAgent.device.isPhone ? 35 : 50;
      }
      return off;
    },
    setSection(obj) {
      this.$store.commit('setRouteFromParams', {
        name: this.$route.meta.page,
        params: {
          ...obj
        }
      });
    }
  }
};
</script>
